import styled from 'styled-components';
import { FlexRow } from 'styles/Layout';

export const SectionEditButton = styled(FlexRow)`
  height: 22px;
  align-items: center;
  cursor: pointer;
  & span {
    height: 22px;
    line-height: 22px;
    margin-left: 10px;
    color: #855ef3;
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const Button = styled.button`
  height: 35px;
  border: 0;
  border-radius: 2px;
  text-decoration: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  outline: 0;
  transition: background-color 0.1s linear;
  &:disabled {
    background-color: #ececec !important;
    cursor: default;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0);
  }
`;

export const DefaultButton = styled(Button)`
  color: ${({ color }) => (color ? color : '#4a4a4a')};
  background-color: #fff;
  font-weight: ${({ bold }) => (bold ? 600 : 500)};
  &:hover {
    background-color: #ededed;
  }
  &:focus {
    background-color: #fff;
  }
`;

export const PrimaryButton = styled(Button)`
  color: #ffffff;
  background-color: #278c7e;
  &:hover {
    background-color: #278c7e;
  }
  &:focus {
    background-color: #278c7e;
  }
`;

export const AdvisorPrimaryButton = styled(Button)`
  color: #ffffff;
  border-radius: 17.5px;
  background-color: #748796;
  line-height: 35px;
  letter-spacing: 0.4px;
  &:hover {
    background: #515e69;
  }
  &:disabled {
    border: 1px solid #cdcdcd;
    background-color: #ededed;
    color: #9b9b9b;
  }
`;

export const AdvisorBlankButton = styled(AdvisorPrimaryButton)`
  background: #ffffff;
  color: #e1701d;
  &:hover {
    background: #eee;
  }
`;

export const LinkButton = styled(Button)`
  color: #278c7e;
  height: 17px;
  background-color: transparent;
  margin: 0;
  padding: 0;
  font-size: 14px;
  box-shadow: none;
  font-weight: 500;
  &:disabled {
    opacity: 0.5;
  }
  &:hover {
    color: #278c7e;
    text-decoration: underline;
  }
  &:focus {
    color: #278c7e;
  }
`;

export const BasicButton = styled(Button)`
  margin: 0;
  padding: 0;
  transition: background-color 0.2s linear;
  letter-spacing: 0.5px;
`;

export const BasicStyledButton = styled(BasicButton)`
  height: 35px;
  width: 300px;
`;

export const TextStyledButton = styled.button`
  height: 17px;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  text-decoration: none;
  color: #278c7e;
  outline: 0;
  font-size: 14px;
  opacity: 1;
  cursor: pointer;
  letter-spacing: 0.5px;
  transition: background-color 0.2s linear;
  &:disabled {
    opacity: 0.5;
  }
  &:hover {
    color: ${({ color = '#278C7E' }) => color};
    text-decoration: underline;
  }
  &:focus {
    color: ${({ color = '#278C7E' }) => color};
  }
`;

export const ContractPrimaryButton = styled(Button)`
  background: #3e7cca;
  color: #ffffff;
  width: 100%;
  height: 35px;
  margin: 0 5px;
  &:hover {
    background: #515e69;
  }
  &:disabled {
    background-color: #ededed;
    color: #9b9b9b;
  }
`;

export const ContractRoundedButton = styled(Button)`
  background: #2f9bec;
  color: white;
  width: 100%;
  height: 40px;
  border-radius: 20px;
  font-weight: normal;
  &:disabled {
    background: #ededed;
    color: #9b9b9b;
  }
`;

export const PrimaryButtonWhite = styled(Button)`
  width: 100%;
  box-shadow: none;
  background-color: #ffffff;
  color: #278c7e;
  border: 1px solid #278c7e;
  &:hover {
    color: #f3f1ff;
    background-color: #278c7e;
  }
  &:disabled {
    background: #ececec;
    color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    border: none;
  }
`;
